<template>
    <slider ref="slider" id="product-slider" class="product-slider" :settings="hooperSettings" style="width: calc(100% - 40px)">
        <slide class="product-slide" v-for="(product, index) in products" :key="product.id" :index="index">
            <div class="product-slide-inner">
                <img class="product-slide__image" :src="product.img.big" :alt="product.name" ondragstart="return false">

                <div class="product-slide__info-wrapper">
                    <div class="product-slide__price font-size-3 font-weight-bold currency">{{ product.price }}</div>
                    <div class="product-slide__title">{{ product.name }}</div>
                    <div class="product-slide__meta">{{ product.weight.value }} {{ product.weight.unit }}</div>
                    <product-counter class="mt-2" :product="product" :transparent="false" :buttonIfZero="true"></product-counter>
                </div>
            </div>
        </slide>

        <navigation slot="hooper-addons"></navigation>
    </slider>
</template>

<script>
import { Hooper as Slider, Slide, Navigation } from 'hooper';

export default {
    name: 'ProductSlider',
    props: [ 'products' ],
    components: { Slider, Slide, Navigation },

    data() {
        return {
            hooperSettings: {
                infiniteScroll: true,
                wheelControl: false,
                breakpoints: {
                    1440: {
                        itemsToShow: 5
                    },
                    600: {
                        itemsToShow: 4
                    },
                    520: {
                        itemsToShow: 3.3
                    },
                    0: {
                        itemsToShow: 2.3
                    }
                }
            }
        };
    },

    mounted() {
        this.$nextTick(() => {
            this.$refs.slider.$el.style.width = '';

            if (window.innerWidth < 1024) this.$refs.slider.updateWidth();
        });
    }
}
</script>

<style lang="scss">
    @import '../../../sass/components/product-slider.scss';
</style>
